import React, { createContext, useContext, useState, useEffect } from 'react';
import huTranslations from '../locales/hu.json';
import enTranslations from '../locales/en.json';

const translations = {
  hu: huTranslations,
  en: enTranslations
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    // 1. Ellenőrizzük, hogy van-e már mentett preferencia
    const savedLang = localStorage.getItem('archerynexus_lang');
    if (savedLang && translations[savedLang]) {
      return savedLang;
    }
    // 2. Ha nincs, megvizsgáljuk a böngésző nyelvét (navigator.language)
    const browserLang = navigator.language || navigator.userLanguage || 'hu';
    if (browserLang.toLowerCase().startsWith('hu')) {
      return 'hu';
    }
    // 3. Minden egyéb külföldi nyelv / ország esetén alapból angol
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('archerynexus_lang', locale);
  }, [locale]);

  const t = (key) => {
    const dict = translations[locale] || translations.hu;
    return dict[key] || translations.hu[key] || key;
  };

  const changeLanguage = (newLang) => {
    if (translations[newLang]) {
      setLocale(newLang);
    }
  };

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
};
